module.exports = __webpack_public_path__ + "img/logoseebcontec.d5e41dcd.svg";